<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  import Promo2018 from './Promo2018.vue'


  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */

  /**
   * プロモ2018のアイテム情報群
   * @type {ItemInfo[]}
   */
  const itemsPromo2018 = Promo2018.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2022-03-22',
        major: [
          '第3弾',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-01',
            rare        : 'KR',
            name        : 'ロマンスビートキラッとワンピ',
            imgUrl      : '/images/items/PCH3-01.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 1900,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-02',
            rare        : 'KR',
            name        : 'ロマンスビートキラッとシューズ',
            imgUrl      : '/images/items/PCH3-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-03',
            rare        : 'KR',
            name        : 'ロマンスビートキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH3-03.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'KR',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-04',
            rare        : 'KR',
            name        : 'シークレットアリスキラッとワンピ',
            imgUrl      : '/images/items/PCH3-04.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 1900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-05',
            rare        : 'KR',
            name        : 'シークレットアリスキラッとシューズ',
            imgUrl      : '/images/items/PCH3-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-06',
            rare        : 'KR',
            name        : 'シークレットアリスキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH3-06.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-07',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトブルートップス',
            imgUrl      : '/images/items/PCH3-07.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-08',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトブルースカート',
            imgUrl      : '/images/items/PCH3-08.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-09',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトブルーシューズ',
            imgUrl      : '/images/items/PCH3-09.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-10',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトブルーヘアアクセ',
            imgUrl      : '/images/items/PCH3-10.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-11',
            rare        : 'PR',
            name        : 'サマーメイドホワイトスカイトップス',
            imgUrl      : '/images/items/PCH3-11.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-12',
            rare        : 'PR',
            name        : 'サマーメイドホワイトスカイスカート',
            imgUrl      : '/images/items/PCH3-12.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-13',
            rare        : 'PR',
            name        : 'サマーメイドホワイトスカイシューズ',
            imgUrl      : '/images/items/PCH3-13.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-14',
            rare        : 'PR',
            name        : 'サマーメイドホワイトスカイヘアアクセ',
            imgUrl      : '/images/items/PCH3-14.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-15',
            rare        : 'PR',
            name        : 'はなやかゆかたももいろトップス',
            imgUrl      : '/images/items/PCH3-15.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-16',
            rare        : 'PR',
            name        : 'はなやかゆかたももいろスカート',
            imgUrl      : '/images/items/PCH3-16.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 3 },
            numReleased : { kira: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-17',
            rare        : 'PR',
            name        : 'はなやかゆかたももいろシューズ',
            imgUrl      : '/images/items/PCH3-17.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-18',
            rare        : 'PR',
            name        : 'はなやかゆかたももいろヘアアクセ',
            imgUrl      : '/images/items/PCH3-18.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-19',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフトップス',
            imgUrl      : '/images/items/PCH3-19.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-20',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフスカート',
            imgUrl      : '/images/items/PCH3-20.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-21',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフシューズ',
            imgUrl      : '/images/items/PCH3-21.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-22',
            rare        : 'SR',
            name        : 'サマーメイドホワイトリーフヘアアクセ',
            imgUrl      : '/images/items/PCH3-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-23',
            rare        : 'SR',
            name        : 'ワイズガールレッドトップス',
            imgUrl      : '/images/items/PCH3-23.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-24',
            rare        : 'SR',
            name        : 'ワイズガールレッドスカート',
            imgUrl      : '/images/items/PCH3-24.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-25',
            rare        : 'SR',
            name        : 'ワイズガールレッドシューズ',
            imgUrl      : '/images/items/PCH3-25.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-26',
            rare        : 'SR',
            name        : 'ワイズガールレッドヘアアクs',
            imgUrl      : '/images/items/PCH3-26.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-27',
            rare        : 'SR',
            name        : 'ハッピースウィムパステルワンピ',
            imgUrl      : '/images/items/PCH3-27.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-28',
            rare        : 'SR',
            name        : 'ハッピースウィムパステルシューズ',
            imgUrl      : '/images/items/PCH3-28.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-29',
            rare        : 'SR',
            name        : 'ハッピースウィムパステルヘアアクセ',
            imgUrl      : '/images/items/PCH3-29.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'SR',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-30',
            rare        : 'SR',
            name        : 'クラシックハートグリーントップス',
            imgUrl      : '/images/items/PCH3-30.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-31',
            rare        : 'SR',
            name        : 'クラシックハートグリーンスカート',
            imgUrl      : '/images/items/PCH3-31.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-32',
            rare        : 'SR',
            name        : 'クラシックハートグリーンシューズ',
            imgUrl      : '/images/items/PCH3-32.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-33',
            rare        : 'SR',
            name        : 'クラシックハートグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH3-33.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-34',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームブルートップス',
            imgUrl      : '/images/items/PCH3-34.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'PS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-35',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームブルースカート',
            imgUrl      : '/images/items/PCH3-35.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'PS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-36',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームブルーシューズ',
            imgUrl      : '/images/items/PCH3-36.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-37',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームブルーヘアアクセ',
            imgUrl      : '/images/items/PCH3-37.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PS',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-38',
            rare        : 'R',
            name        : 'レッドギンガムサマーワンピ',
            imgUrl      : '/images/items/PCH3-38.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-39',
            rare        : 'R',
            name        : 'レッドギンガムサマーシューズ',
            imgUrl      : '/images/items/PCH3-39.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-40',
            rare        : 'R',
            name        : 'レッドギンガムむぎわらハット',
            imgUrl      : '/images/items/PCH3-40.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'R',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-41',
            rare        : 'R',
            name        : 'ストライプスターオレンジトップス',
            imgUrl      : '/images/items/PCH3-41.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-42',
            rare        : 'R',
            name        : 'ストライプスターオレンジスカート',
            imgUrl      : '/images/items/PCH3-42.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-43',
            rare        : 'R',
            name        : 'ストライプスターオレンジシューズ',
            imgUrl      : '/images/items/PCH3-43.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-44',
            rare        : 'R',
            name        : 'ストライプスターオレンジヘアアクセ',
            imgUrl      : '/images/items/PCH3-44.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-45',
            rare        : 'R',
            name        : 'メロディーピンクブラウス',
            imgUrl      : '/images/items/PCH3-45.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 12 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-46',
            rare        : 'R',
            name        : 'メロディーピンクスカート',
            imgUrl      : '/images/items/PCH3-46.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-47',
            rare        : 'R',
            name        : 'メロディーピンクシューズ',
            imgUrl      : '/images/items/PCH3-47.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-48',
            rare        : 'R',
            name        : 'メロディーピンクヘアアクセ',
            imgUrl      : '/images/items/PCH3-48.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-49',
            rare        : 'R',
            name        : 'スターダストブルーグラデワンピ',
            imgUrl      : '/images/items/PCH3-49.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-50',
            rare        : 'R',
            name        : 'スターダストブルーグラデシューズ',
            imgUrl      : '/images/items/PCH3-50.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-51',
            rare        : 'R',
            name        : 'スターダストブルーグラデヘアアクセ',
            imgUrl      : '/images/items/PCH3-51.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'R',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-52',
            rare        : 'R',
            name        : 'マドモアゼルワインレッドワンピ',
            imgUrl      : '/images/items/PCH3-52.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-53',
            rare        : 'R',
            name        : 'マドモアゼルワインレッドシューズ',
            imgUrl      : '/images/items/PCH3-53.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-54',
            rare        : 'R',
            name        : 'マドモアゼルワインレッドヘアアクセ',
            imgUrl      : '/images/items/PCH3-54.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-55',
            rare        : 'N',
            name        : 'フラワーパターンワンピ',
            imgUrl      : '/images/items/PCH3-55.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-56',
            rare        : 'N',
            name        : 'フラワーパターンパンプス',
            imgUrl      : '/images/items/PCH3-56.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-57',
            rare        : 'N',
            name        : 'スポーティバッジパーカ',
            imgUrl      : '/images/items/PCH3-57.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-58',
            rare        : 'N',
            name        : 'スポーティバッジスカート',
            imgUrl      : '/images/items/PCH3-58.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-59',
            rare        : 'N',
            name        : 'スポーティバッジスニーカー',
            imgUrl      : '/images/items/PCH3-59.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-60',
            rare        : 'N',
            name        : 'ロックハートレザーノースリーブ',
            imgUrl      : '/images/items/PCH3-60.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 12 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-61',
            rare        : 'N',
            name        : 'ロックハートスカート',
            imgUrl      : '/images/items/PCH3-61.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-62',
            rare        : 'N',
            name        : 'ロックハートあみあげブーツ',
            imgUrl      : '/images/items/PCH3-62.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-63',
            rare        : 'N',
            name        : 'ブルーローズリボントップス',
            imgUrl      : '/images/items/PCH3-63.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-64',
            rare        : 'N',
            name        : 'ブルーローズリボンスカート',
            imgUrl      : '/images/items/PCH3-64.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 11 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-65',
            rare        : 'N',
            name        : 'ブルーローズリボンパンプス',
            imgUrl      : '/images/items/PCH3-65.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 300,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-66',
            rare        : 'N',
            name        : 'オトナガーリーワンピ',
            imgUrl      : '/images/items/PCH3-66.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 12 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-67',
            rare        : 'N',
            name        : 'オトナガーリーブーツ',
            imgUrl      : '/images/items/PCH3-67.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PS',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),
          item({
            collection  : '第3弾',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '第3弾',
            id          : 'PCH3-68',
            rare        : 'SR',
            name        : 'まっかなスイカ',
            imgUrl      : '/images/items/PCH3-68.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-69',
            rare        : 'SR',
            name        : 'キラッCHU',
            imgUrl      : '/images/items/PCH3-69.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-70',
            rare        : 'SR',
            name        : 'ゴールドクイーンステッキ',
            imgUrl      : '/images/items/PCH3-70.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '第3弾',
            id          : 'PCH3-71',
            rare        : 'R',
            name        : 'かきごおりいちごあじ',
            imgUrl      : '/images/items/PCH3-71.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-72',
            rare        : 'R',
            name        : 'ファンシーわたあめ',
            imgUrl      : '/images/items/PCH3-72.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            id          : 'PCH3-73',
            rare        : 'R',
            name        : 'プリ☆チャンキャストラブリーピンク',
            imgUrl      : '/images/items/PCH3-73.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 10 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '第3弾',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] なかよしチャンネル
          // ================================================================================

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH3-87',
            rare        : 'SR',
            name        : 'ブルークイーンステッキ',
            imgUrl      : '/images/items/PCH3-87.png',
            kind        : 'パシャッとアイテム',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 期間限定チャンネル
          // ================================================================================

          item({
            collection  : 'サマーメイドブラックピーチチャンネル',
            id          : 'PCH3-79',
            rare        : 'SR',
            name        : 'サマーメイドブラックピーチトップス',
            imgUrl      : '/images/items/PCH3-79.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマーメイドブラックピーチチャンネル',
            id          : 'PCH3-80',
            rare        : 'SR',
            name        : 'サマーメイドブラックピーチスカート',
            imgUrl      : '/images/items/PCH3-80.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマーメイドブラックピーチチャンネル',
            id          : 'PCH3-81',
            rare        : 'SR',
            name        : 'サマーメイドブラックピーチシューズ',
            imgUrl      : '/images/items/PCH3-81.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'サマーメイドブラックピーチチャンネル',
            id          : 'PCH3-82',
            rare        : 'SR',
            name        : 'サマーメイドブラックピーチヘアアクセ',
            imgUrl      : '/images/items/PCH3-82.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'はなやかゆかたチャンネル',
            id          : 'PCH3-83',
            rare        : 'SR',
            name        : 'はなやかゆかたゆずいろトップス',
            imgUrl      : '/images/items/PCH3-83.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'はなやかゆかたチャンネル',
            id          : 'PCH3-84',
            rare        : 'SR',
            name        : 'はなやかゆかたゆずいろスカート',
            imgUrl      : '/images/items/PCH3-84.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'はなやかゆかたチャンネル',
            id          : 'PCH3-85',
            rare        : 'SR',
            name        : 'はなやかゆかたゆずいろシューズ',
            imgUrl      : '/images/items/PCH3-85.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'はなやかゆかたチャンネル',
            id          : 'PCH3-86',
            rare        : 'SR',
            name        : 'はなやかゆかたゆずいろヘアアクセ',
            imgUrl      : '/images/items/PCH3-86.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '期間限定 ラスカル',
            id          : 'PCH3-74',
            rare        : 'SR',
            name        : 'ラスカルオールフレンズトップス',
            imgUrl      : '/images/items/PCH3-74.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '期間限定 ラスカル',
            id          : 'PCH3-75',
            rare        : 'SR',
            name        : 'ラスカルオールフレンズスカート',
            imgUrl      : '/images/items/PCH3-75.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '期間限定 ラスカル',
            id          : 'PCH3-76',
            rare        : 'SR',
            name        : 'ラスカルオールフレンズシューズ',
            imgUrl      : '/images/items/PCH3-76.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '期間限定 ラスカル',
            id          : 'PCH3-77',
            rare        : 'SR',
            name        : 'ラスカルオールフレンズヘアアクセ',
            imgUrl      : '/images/items/PCH3-77.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '期間限定 すみっコ',
            id          : 'PCH3-78',
            rare        : 'R',
            name        : 'すみっコぐらし ねこ＆たぴおか',
            imgUrl      : '/images/items/PCH3-78.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '期間限定',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '期間限定',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '期間限定',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ブランドチャンネル
          // ================================================================================

          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-08',
            rare        : 'SR',
            name        : 'ミントギンガムサマーワンピ',
            imgUrl      : '/images/items/SH-08.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-09',
            rare        : 'SR',
            name        : 'ミントギンガムサマーシューズ',
            imgUrl      : '/images/items/SH-09.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            id          : 'SH-10',
            rare        : 'SR',
            name        : 'ミントギンガムむぎわらハット',
            imgUrl      : '/images/items/SH-10.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sweet Honey チャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-08',
            rare        : 'SR',
            name        : 'ストライプスターライトブルートップス',
            imgUrl      : '/images/items/GY-08.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-09',
            rare        : 'SR',
            name        : 'ストライプスターライトブルースカート',
            imgUrl      : '/images/items/GY-09.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-10',
            rare        : 'SR',
            name        : 'ストライプスターライトブルーシューズ',
            imgUrl      : '/images/items/GY-10.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Girl\'s Yell チャンネル',
            id          : 'GY-11',
            rare        : 'SR',
            name        : 'ストライプスターライトブルーヘアアクセ',
            imgUrl      : '/images/items/GY-11.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-01',
            rare        : 'SR',
            name        : 'ワイズガールインディゴトップス',
            imgUrl      : '/images/items/SA-01.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-02',
            rare        : 'SR',
            name        : 'ワイズガールインディゴスカート',
            imgUrl      : '/images/items/SA-02.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-03',
            rare        : 'SR',
            name        : 'ワイズガールインディゴシューズ',
            imgUrl      : '/images/items/SA-03.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-04',
            rare        : 'SR',
            name        : 'ワイズガールインディゴヘアアクセ',
            imgUrl      : '/images/items/SA-04.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-05',
            rare        : 'SR',
            name        : 'クラシックハートパープルトップス',
            imgUrl      : '/images/items/SA-05.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-06',
            rare        : 'SR',
            name        : 'クラシックハートパープルスカート',
            imgUrl      : '/images/items/SA-06.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-07',
            rare        : 'SR',
            name        : 'クラシックハートパープルシューズ',
            imgUrl      : '/images/items/SA-07.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-08',
            rare        : 'SR',
            name        : 'クラシックハートパープルヘアアクセ',
            imgUrl      : '/images/items/SA-08.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] サマーメイドスペシャル大会
          // ================================================================================

          externalItem(itemsPromo2018, 'SP-005'),
          externalItem(itemsPromo2018, 'SP-006'),
          externalItem(itemsPromo2018, 'SP-007'),
          externalItem(itemsPromo2018, 'SP-008'),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, {  rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, {  rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsNakayoshiChannel () {
        return _.where(this.itemsFiltered, { collection: 'なかよしチャンネル' })
      },

      itemsRascal () {
        return _.where(this.itemsFiltered, { collection: '期間限定 ラスカル' })
      },

      itemsSumikko () {
        return _.where(this.itemsFiltered, { collection: '期間限定 すみっコ' })
      },

      itemsSMBPChannel () {
        return _.where(this.itemsFiltered, { collection: 'サマーメイドブラックピーチチャンネル' })
      },

      itemsHYChannel () {
        return _.where(this.itemsFiltered, { collection: 'はなやかゆかたチャンネル' })
      },

      itemsSHChannel () {
        return _.where(this.itemsFiltered, { collection: 'Sweet Honey チャンネル' })
      },

      itemsGYChannel () {
        return _.where(this.itemsFiltered, { collection: 'Girl\'s Yell チャンネル' })
      },

      itemsSAChannel () {
        return _.where(this.itemsFiltered, { collection: 'Secret Alice チャンネル' })
      },

      itemsSummerMaidSP () {
        return _.where(this.items, { collection: 'サマーメイドスペシャル大会' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[3]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="期間限定 SR ★★" color="#00c7da" :items="itemsRascal" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col3>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="期間限定 パシャッとアイテム" color="#c598ff" :items="itemsSumikko" />
      <ItemList title="なかよしチャンネル" color="#c598ff" :items="itemsNakayoshiChannel" />
    </template>

    <template #col4>
      <ItemList title="サマーメイドスペシャル大会" color="#a1c0fa" :items="itemsSummerMaidSP" />
      <ItemList title="サマーメイドブラックピーチチャンネル" color="#a1c0fa" :items="itemsSMBPChannel" />
      <ItemList title="はなやかゆかたチャンネル" color="#a1c0fa" :items="itemsHYChannel" />
      <ItemList title="Sweet Honey チャンネル" color="#a1c0fa" :items="itemsSHChannel" />
      <ItemList title="Girl's Yell チャンネル" color="#a1c0fa" :items="itemsGYChannel" />
      <ItemList title="Secret Alice チャンネル" color="#a1c0fa" :items="itemsSAChannel" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
